

export const LOG_MESSAGE = "LOG_MESSAGE"

export const CLEAR_MESSAGE = "CLEAR_MESSAGE"